// Object to store the SDK features that are enabled/disabled
const sdkFeatures = {
    hasSDKVersionUI: true,
    hasVersionHistory: true,
    cfVisibility: true,
    patternResolution: true,
};

export { sdkFeatures };
//# sourceMappingURL=sdkFeatures.js.map
